import { createSlice} from "@reduxjs/toolkit";
import { toast } from "react-toastify"
import Cookies from "js-cookie"




const initialState = {
    cartItems: Cookies.get('rndsan_cart') ? JSON.parse(Cookies.get('rndsan_cart')).cartItems||[] : [],
    total: Cookies.get('rndsan_cart') ? JSON.parse(Cookies.get('rndsan_cart')).total||0 : 0,
    totalPrice:Cookies.get('rndsan_cart') ? JSON.parse(Cookies.get('rndsan_cart')).totalPrice||0 : 0,
    
}

export const Cart_system = createSlice({
    name: "cart",
    initialState,
    reducers: {

            fetchingState(state,action){  // this function is to fetch state data  from api , so  it is only used in fetching data from api
                state=action.payload

                
                 Cookies.set('rndsan_cart', JSON.stringify(state));
                 console.log(state);
                 
            },

     addCartItem(state, action) {
            
            const existingItem = state.cartItems.find(item => item.id === action.payload.id);
            if (existingItem) {
                return toast.error("Item already exists in the cart");
            }else{
                console.log("data cart:",action.payload);
                
                
            state.cartItems = [action.payload, ...state.cartItems];
            state.total += 1;
            state.totalPrice += Number(action.payload.price); 
                         
            }
           
        },


             emptyCart(state) {
            state.cartItems = [];
            state.total = 0;
            state.totalPrice = 0;
           //const res= await clearItemFromCart()
          // console.log(res);
           
            Cookies.set('rndsan_cart', "");
        },

        cartItemQuantityIncreament(state, action) {
            const item = state.cartItems.find(item => item.id === action.payload.id);
            if(item){
            if ( item.stock > item.quantity) {
                item.quantity += 1;
                
                state.totalPrice += Number(item.price);
                Cookies.set('rndsan_cart', JSON.stringify(state));
                
            }else{
                toast.info("Product stock has reached")
            }}
        },

         cartItemQuantityDecreament(state, action) {
            const item = state.cartItems.find(item => item.id === action.payload.id);
            if (item&& item.quantity > 1) {
                item.quantity -= 1;
               
                state.totalPrice -= Number(item.price);
                Cookies.set('rndsan_cart', JSON.stringify(state));
              
               
            }
        },

        
          cartItemDecreament(state, action) {
            const item = state.cartItems.find(item => item.id === action.payload.id);
            if (item) {
               
                state.total -= 1;
                state.totalPrice -=( Number(item.price)* item.quantity);
                state.cartItems = state.cartItems.filter(item => item.id !== action.payload.id);

                Cookies.set('rndsan_cart', JSON.stringify(state));
                 
            }
        },
        
    },

})
export const {addCartItem, emptyCart, cartItemQuantityDecreament,cartItemQuantityIncreament,cartItemDecreament,fetchingState } = Cart_system.actions

export default Cart_system.reducer